import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/errorimg.svg")